Vendd.Scripts.load(function () {

    var $wrapper = $('.x-pd-tab-panel');

    if ($wrapper.length < 1) return;

    //Check attributes tab
    updateAttributesTab();

    if ($wrapper.hasClass('anchor-tabs')) {
        //Scroll to each section
        scrollToSection();
        //Sticky anchors
        stickyAnchors();
        $(window).scroll(_.throttle(stickyAnchors, 100));
        //Anchors behaviour on scroll
        initTabAnchors();

        //Show/Hide tabs in mobile
        if (isTouch()) initTabsAccordion();
    } else {
        initTabsAccordion();
    }

    //init iframe tab

    initIframeTab();

    function updateAttributesTab() {

        var $box = $('.js-attributes'),
            $container = $('.js-attributes-container'),
            visible = false;

        if ($box.length > 0 || $container.length > 0) {
            $('[class*="ItemAttributes_"]', $box).each(function () {
                if (!$(this).hasClass('ItemAttributes_IsTest') && !$(this).hasClass('ItemAttributes_Gender') && !$(this).hasClass('ItemAttributes_OverWeight') && !$(this).hasClass('ItemAttributes_Latitude') && !$(this).hasClass('ItemAttributes_Longitude') && !$(this).hasClass('ItemAttributes_Address')) {
                    visible = true;
                }
            });

            if (($('[class*="ItemAttributes_"]', $box).length > 0) && visible) {
                $container.removeAttr('style');
                $('.product-details-region .x-tab-panel .tabs-content > ul > li:eq(1) .mb-title').removeAttr('style');
                $container.each(function () { $(this).removeClass('hidden'); });
            } else {
                $container.each(function () { $(this).remove(); });
            }
        }
    }

    function initTabsAccordion() {

        var $wrapper = $('.x-pd-tab-panel');

        if ($wrapper.hasClass('horizontal-tabs')) {
            $('.tabs-title > ul > li:first-child', $wrapper).addClass('active');
            $('.tabs-content > ul > li:first-child', $wrapper).addClass('active');
        }

        $('.mb-title', $wrapper).click(function () {

            if ($wrapper.hasClass('anchor-tabs') && $(window).width() > 959) return;

            var index = $(this).parent().index();
            if ($(this).parent().hasClass('active')) {
                $('.tabs-title > ul > li:eq(' + index + ')', $wrapper).removeClass('active');
                $('.tabs-content > ul > li:eq(' + index + ')', $wrapper).removeClass('active');
                $('.tabs-content > ul > li:eq(' + index + ')', $wrapper).children('.mb-title').addClass('icon-arrow-down').removeClass('icon-arrow-up');
            } else {
                $('.tabs-title > ul > li:eq(' + index + ')', $wrapper).addClass('active').siblings('.active').removeClass('active');
                $('.tabs-content > ul > li:eq(' + index + ')', $wrapper).addClass('active').siblings('.active').removeClass('active').children('.mb-title').addClass('icon-arrow-down').removeClass('icon-arrow-up');
                $('.tabs-content > ul > li:eq(' + index + ')', $wrapper).children('.mb-title').addClass('icon-arrow-up').removeClass('icon-arrow-down');
            }
        });

    }

    function scrollToSection() {

        var $wrapper = $('.x-pd-tab-panel');
        var $container = $('.tabs-title', $wrapper);
        var $anchor = $('.anchor', $container);
        var $stickyBarHeight = $('.sticky-header-region').height() || 0;
        var $stickyAnchorsHeight = $container.height() || 0;

        $anchor.click(function () {
            var $thisAnchor = $(this);
            var $tabIndex = $thisAnchor.closest('li').index();
            var $sectionToScroll = $('.tab-content:eq(' + $tabIndex + ')');

            if (!$thisAnchor.hasClass('selected')) {
                $anchor.removeClass('selected');
                $thisAnchor.addClass('selected');
            }
            var scrollTopAmount;

            if ((!isTouch() && $(window).width() < 1200) || isTouch()) {
                scrollTopAmount = $sectionToScroll.offset().top - $stickyAnchorsHeight;
            }
            else {
                scrollTopAmount = $sectionToScroll.offset().top - ($stickyBarHeight + $stickyAnchorsHeight);
            }

            $('html, body').animate({ scrollTop: scrollTopAmount }, 400);
        });

    }

    function initTabAnchors() {

        if ($(window).width() < 960) return;

        var $wrapper = $('.x-pd-tab-panel');
        var $container = $('.tabs-title', $wrapper);
        var $anchor = $('.anchor', $container);
        var $contentContainer = $('.tabs-content', $wrapper);
        var $content = $('.tab-content', $contentContainer);
        var $stickyBarHeight = $('.sticky-header-region').height() || 0;
        var $stickyAnchorsHeight = $container.height() || 0;
        var offsetArray = [];
        var isLastElement = false;
        var firstScroll = true;     

        $(window).scroll(_.throttle(function () {

            if (firstScroll) {
                //Add offsets to an Array
                _.each($content, function (content, index) {
                    offsetArray.push($(content).offset().top - ($stickyBarHeight + $stickyAnchorsHeight + 1));
                }); 
            }

            //Enable every anchor when scroll is in appropriate height
            _.each(offsetArray, function (offset, index) {

                if (index == offsetArray.length - 1) {
                    isLastElement = true;
                } else {
                    isLastElement = false;
                }
                    
                if (isLastElement) {
                    if ($(window).scrollTop() >= offsetArray[index]) {
                        $anchor.removeClass('selected');
                        $('li.tab-title:eq(' + index + ')').find($anchor).addClass('selected');
                    }
                } else {
                    if ($(window).scrollTop() >= offsetArray[index] && $(window).scrollTop() < offsetArray[index + 1]) {
                        $anchor.removeClass('selected');
                        $('li.tab-title:eq(' + index + ')').find($anchor).addClass('selected');
                    }
                }
            });

            //Init anchors when scroll on top
            if ($(window).scrollTop() == 0) {
                $anchor.removeClass('selected');
            }

            firstScroll = false;
        }, 100));
             
    } 

    function stickyAnchors() {

        if ($(window).width() < 960) return;

        var $wrapper = $('.x-pd-tab-panel');
        var $container = $('.tabs-title', $wrapper);
        var $offsetTop = $container.offset().top;
        var $stickyBarHeight = $('.sticky-header-region').height() || 0;

        if ($(window).scrollTop() < $offsetTop - $stickyBarHeight) {
            $container.removeClass('sticky');
        } else {
            $container.addClass('sticky');
        }

    }

    function initIframeTab() {

        var $container = $('.js-external-content');

        if ($container.length < 1) return;

        $('#external-content-iframe').on("load", function () {
            var $this = $(this);
            calculateIframeHeight($this);
        });

        $('.mb-title', $container).click(function () {

            if ($(window).width() > 959) return;

            if ($(this).parent().hasClass('active')) {
                var $iframe = $('#external-content-iframe');
                calculateIframeHeight($iframe);
            }
        });
    }

    function calculateIframeHeight(iframe) {
        var height = iframe.contents().height() + 100;
        iframe.css('height', height);
    }
});







